<template>
  <div
    class="flex flex-col items-center justify-center pass-expired-success-wrapper"
  >
    <div
      class="w-32 h-32 bg-zt-success flex justify-center items-center rounded-full mt-12"
    >
      <img
        src="../../../../../public/assets/images/check-success.svg"
        alt="check-success"
      />
    </div>
    <div class="text-center my-12 text-center w-3/4">
      <h1 class="success-message text-zt-xl mb-4">
        {{ $t("message.passwordExpired.success.success_message") }}
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "ztPasswordExpiredSuccess",

  methods: {},
};
</script>

<style scoped lang="scss">
.pass-expired-success-wrapper {
  height: 394px;
}

::v-deep .zt-button {
  height: 3.25rem;
}

.success-message {
  color: #0081c6;
}
</style>
